import { BaseApi } from './base-api';
import { IResponsePadrao } from '../types/response-padrao';

export type TrackeamentoCheckoutDto = {
  id?: string;
  checkoutId: string;
  nome?: string;
  sobrenome?: string;
  telefone?: string;
  email?: string;
  rua?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  pais?: string;
  cep?: string;
  doc1?: string;
  doc2?: string;
  ultimoEvento?: string;
  urlParams?: Record<string, string>;
};

export type TrackeamentoResponse = TrackeamentoCheckoutDto & {
  id: string;
  ip?: string;
  createdAt?: string;
};

/**
 * Cliente da API de trackeamento de checkout (carrinho abandonado).
 * Envia dados conforme o comprador preenche o formulário para que o
 * `vendepay-financeiro-ms` agende o webhook `CARRINHO_ABANDONADO` caso
 * ele saia do checkout sem comprar.
 */
export class TrackeamentoApi extends BaseApi<TrackeamentoResponse> {
  constructor() {
    super('trackeamento');
  }

  async criar(
    data: TrackeamentoCheckoutDto,
  ): Promise<IResponsePadrao<TrackeamentoResponse>> {
    return (await this.api.post('/trackeamento', data)).data;
  }

  async atualizar(
    data: TrackeamentoCheckoutDto,
  ): Promise<IResponsePadrao<TrackeamentoResponse>> {
    return (await this.api.put('/trackeamento', data)).data;
  }
}
